import React, { useEffect, useState } from 'react'

import { useLazyQuery } from '@apollo/client'
import PropTypes from 'prop-types'

import styles from './style.module.scss'
import { CURRENT_SERIES_LIST } from '@graphql/globalwidget/rankings.query'
import { S3_PREFIX } from '@shared-submodule/sm-constants'
import CustomLink from '@shared/components/customLink'
import { allRoutes } from '@shared-submodule/sm-constants/allRoutes'
import Skeleton from '@shared/components/skeleton'
import MyImage from '@shared/components/myImage'
import seriesImg from '@assets/images/placeholder/series-placeholder.svg'
import WidgetCardHeader from '../widgetHeader'

function CurrentSeries({ dataSSR }) {
  const [list, setList] = useState([])
  const [getCurrentPopularSeries, { data, loading }] = useLazyQuery(CURRENT_SERIES_LIST, { context: { headers: { 'Cache-Control': 'public, max-age=300, s-maxage=600, stale-while-revalidate=420' } } })
  useEffect(() => {
    !dataSSR && getCurrentPopularSeries()
  }, [])
  useEffect(() => {
    const sourceData = dataSSR || data
    const results = sourceData?.getCurrentPopularSeries?.aResults || []
    setList(results.slice(0, 5))
  }, [dataSSR, data])

  return (
    <>
      {list?.length !== 0 &&
        <section className="widget">
          <WidgetCardHeader headerText={'Current Series'} link={allRoutes.cricketSeriesNew} internalLink={true} />
          <div className={`${styles.block} font-semi items common-box mb-0`}>
            {list?.map((series) => {
              return (
                <CustomLink key={series?._id} href={`/${series?.oSeries?.oCategory?.oSeo?.sSlug || series?.oSeries?.oSeo?.sSlug}`} prefetch={false}>

                  <a className={`${styles.item} cs-item d-flex py-2 py-md-3`}>
                    <div className={`${styles.seriesImg} overflow-hidden`}>
                      <MyImage src={`${S3_PREFIX}${series?.oSeries?.oCategory?.oImg?.sUrl}`} width={26} height={26} errorImage={seriesImg} autoRadiusImage></MyImage>
                    </div>
                    <span className="overflow-hidden text-nowrap">{series?.oSeries?.sTitle}</span>
                  </a>
                </CustomLink>
              )
            })}
            {loading && (
              [0, 1, 2, 3, 4].map((i) => <div key={i} className='bg-white py-2 py-md-3 rounded'> <Skeleton height={'21px'} /> </div>)
            )}
          </div>
        </section>
      }
    </>
  )
}

CurrentSeries.propTypes = {
  dataSSR: PropTypes.object
}

export default CurrentSeries
